import {qs} from '../qs'
import curd from '../curd'

const BASE_PATH = '/task/check'

export default curd(BASE_PATH, {
  saveMaintainOrgs: model => ({
    url: `${BASE_PATH}/maintain`,
    method: 'PUT',
    data: model
  }),
  abortHandle: (params) => ({
    url: `${BASE_PATH}/stop/${params.id}?${qs(params)}`,
    method: 'GET'
  }),
  uploadSitePhoto: photo => ({
    url: `${BASE_PATH}/site/photo`,
    method: 'PUT',
    data: photo
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Task.js